var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHalfTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 418,
    height: 275,
    viewBox: "0 0 418 275",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke: #707070;\n      }\n\n      .cls-2 {\n        clip-path: url(#clip-path);\n      }\n\n      .cls-3 {\n        fill: #eb5d6a;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_73",
    "data-name": "Rectangle 73",
    className: "cls-1",
    width: 418,
    height: 275,
    transform: "translate(868.845 2025.796)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_26",
    "data-name": "Mask Group 26",
    className: "cls-2",
    transform: "translate(-868.845 -2025.796)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    className: "cls-3",
    d: "M137.664,23.629a26.541,26.541,0,0,0-23.337,13.416L27.373,186.38A27,27,0,0,0,50.71,226.973H224.619a27,27,0,0,0,23.337-40.593L161,37.045a26.541,26.541,0,0,0-23.337-13.416m0-23.629a50.166,50.166,0,0,1,43.756,25.155L268.375,174.49c19.655,33.755-4.7,76.112-43.756,76.112H50.71c-39.061,0-63.412-42.357-43.756-76.112L93.908,25.155A50.166,50.166,0,0,1,137.664,0Z",
    transform: "matrix(0.94, -0.342, 0.342, 0.94, 905.628, 1955.339)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalfTriangle);
export default __webpack_public_path__ + "static/media/half_triangle.ceef9dd9d3a35b6346ebf34f0fac295c.svg";
export { ForwardRef as ReactComponent };